@if (show) {
  <div class="error-text" style="text-align: center; padding: 2em; margin: 1em; border: 4px dashed; font-size: 17px">
    {{ 'unsupported-browser' | translate | async }}<br /><br />
    {{ 'unsupported-browser-detected' | translate | async }}:<br />
    {{ browserInfo.name }}: v{{ tunnistettuVersio }}
    @if (minimiVersio) {
      <div>{{ 'unsupported-browser-required' | translate | async }}: v{{ minimiVersio }}</div>
    }
  </div>
}
